import { render } from "./DebugInfo.vue?vue&type=template&id=3e732c1d&scoped=true"
import script from "./DebugInfo.vue?vue&type=script&lang=js"
export * from "./DebugInfo.vue?vue&type=script&lang=js"

import "./DebugInfo.vue?vue&type=style&index=0&id=3e732c1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e732c1d"]])

export default __exports__